import React, { Component } from 'react';
import classnames from 'classnames';
import { TextArea } from '@platform/base';
import './mentions.less'
import classNames from 'classnames';
import { throttle } from '@platform/api';

export default class mentions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: -1, // 当前激活的公式下标
      hintMsg: '', // 函数说明
      hintTop: 0, // 公式说明的top
      showHint: false, // 是否显示函数说明,
      formulaList: [], // 未过滤的公式列表
      filterList: [], // 过滤后的公式列表
      inputValue: '', // 需要高亮的字符
    }
  }
  UNSAFE_componentWillReceiveProps(props) {
    // console.log("UNSAFE_componentWillReceiveProps", props.value)
    if (props.value) { //大写
      this.setState({currentIndex: -1},()=> this.handleFilter(props.value))
    } else {
      // console.log(this.state.filterList.length)
      this.setState({ filterList: [] });
    }
  }
  componentDidMount() {
    this.props.onRef(this);
    this.setState({ formulaList: this.props.formulaList }, () => {
      // console.log('formulaList', this.state.formulaList)
    });
  }
  /**
   * 快捷键选中候选公式  上、下、enter
   */
  handleHotkeysThrottle = key => {
    const _this = this;
    throttle(this.handleHotkeys.call(_this, key), 3000)
  }
  handleHotkeys = key => {
    // console.log(key)
    let { currentIndex, filterList } = this.state;
    let len = filterList.length;
    this.hanleLeave();
    const _this = this;
    // 上
    if (key === 38) {
      if (currentIndex === -1 || currentIndex === 0) {
        currentIndex = len - 1;
      } else {
        currentIndex--;
      }
    } else if (key === 40) {
      // 下
      if (currentIndex === len - 1) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }
    } else if (key === 13 && currentIndex > -1) {
      const inpuStr = filterList[currentIndex]?.inputSig;
      this.handleClick(inpuStr);
      return true; // enter时结束联想
    }
    let _active = document.querySelector(`.mentions-dropdown-li-${currentIndex}`);
    _active?.scrollIntoView({block:'nearest', behavior:'smooth'});
    this.setState({currentIndex}, () => {
      setTimeout(() => { // 确保先滚动后获取dom位置
        _active&&_this.handleHover( filterList[currentIndex], _active);
      },500)
    })
  }
  /**
   * 过滤 匹配的公式
   */
  handleFilter = value => {
    const { formulaList } = this.props;
    // console.log('过滤', value)
    const filterList = formulaList.filter(item => {
      const displayName = item.displayName.toLowerCase();
      const searchValue = value.toLowerCase();
      return displayName.indexOf(searchValue) > -1;
    })
    // console.log(filterList)
    this.setState({ filterList, inputValue: value })
  }
  /**
   * 点击后加入textarea
   */
  handleClick = (inputSig) => {
    this.props.setName(inputSig);
  }
  /**
   * 鼠标划上
   */
  handleHover = (item, event) => {
    // console.log('handleHover', item, event)
    const { hintMsg } = item;
    const hintTop = this.getHintTop(event);
    console.log("hintTop", hintTop)
    this.setState({ showHint: true, hintMsg, hintTop})
  }
  /**
   * 获取函数说明框top位置
   */
  getHintTop = event => {
    const _li = event;
    const _ul = document.querySelector(`.mentions-dropdown-ul`);
    const liBoudingTop = _li?.getBoundingClientRect().top;
    const ulBoudingTop = _ul?.getBoundingClientRect().top;
    const bodyBottom = document.querySelector(".u-modal-body")?.getBoundingClientRect().bottom;
    let top = bodyBottom-liBoudingTop < 94 ? 0: liBoudingTop - ulBoudingTop;
    let hintTop = top > 62 ? 62 : top < 0 ? 0 : top;
    return hintTop;
  }
  /**
   * 鼠标离开
   */
  hanleLeave = () => {
    this.setState({ showHint: false })
  }
  /**
   * 创建函数联想气泡框
   */
  _createFormulaAssociate = () => {
    const { coordinate } = this.props; // 联想气泡框的位置
    const { dropdownTop, dropdownLeft, hintRight, hintLeft } = coordinate;
    let { filterList, inputValue, hintMsg, hintTop, showHint, currentIndex } = this.state;
    return (
      <div className={classnames('mentions-dropdown')} style={{ top: dropdownTop, left: dropdownLeft }}>
        {/* 公式列表 */}
        <ul className={classnames('mentions-dropdown-ul')}>
          {
            filterList.map((item, index) => {
              const { inputSig, category, displayName } = item;
              const _index = displayName.toLowerCase().search(inputValue.toLowerCase());
              const beforeStr = displayName.substr(0, _index);
              const inputStr = displayName.substr(_index, inputValue.length);
              const afterStr = displayName.substr(_index + inputValue.length);
              let title = (
                <span className={classnames('mentions-display')}>
                  {beforeStr}
                  <span style={{ color: '#f53c32' }}>
                    {inputStr}
                  </span>
                  {afterStr}
                </span>
              )
              return (
                <li className={classnames('mentions-dropdown-li', `mentions-dropdown-li-${index}`, currentIndex === index ?'mentions-dropdown-active':'')} key={index} data-name={inputSig} onMouseDown={() => this.handleClick(inputSig)} onMouseEnter={e => this.handleHover(item, e.currentTarget)} onMouseLeave={this.hanleLeave}>
                  {title}
                  <span className={classnames('mentions-category')}>{category}</span>
                </li>
              )
            })
          }
        </ul>
        {/* 公式说明 */}
        <div style={{ top: hintTop, right: hintRight, left: hintLeft, display: showHint ? "block" : "none" }} className={classNames('mentions-hint')}>{hintMsg.length>84?hintMsg.substr(0, 84) + "...": hintMsg}</div>
      </div>
    )
  }
  render() {
    const { filterList } = this.state;
    return filterList.length > 0 && this._createFormulaAssociate()
  }
}
